//Standard library imports
import React, { useEffect, useState } from 'react';
//Internal module imports
import classes from '../Home.module.css';
import { useLoader } from '../../../hooks/use-loader.hook';
import { EconomicsService } from '../../../services/Bidding/EconomicsService';
import { momentTimeFormater } from '../../../utils/dateHelper';
import { AuthContext } from '../../../context/AuthContext';
import EChart from '../../../components/Echarts/Echarts';

const MonthsRevenueCard = () => {
    const [startLoader, stopLoader] = useLoader();
    const [data, setData] = useState([]);
    const [revenue, setRevenue] = useState(0);
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim();

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        const params = {
            startDate: momentTimeFormater().startOf('month').format(),
            endDate: momentTimeFormater().endOf('month').format(),
        };
        EconomicsService.DashboardRevenueCard(params, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => {
        setRevenue(parseInt(data?.data?.totalRevenue).toLocaleString('da'));
        setData(data?.data?.graphData || []);
    };

    const handleError = (error) => {
        console.error(error);
    };

    return (
        <div className={`${classes.TopGraph} ${classes.Revenue}`}>
            <div className={classes.Title}>Month's Revenue</div>
            <div className={classes.RChart}>
                <EChart
                    series={data}
                    showToolBox={false}
                    showTooltip={false}
                    type="line"
                    step={true}
                    lineStyle={{ width: 3, color: primaryColor }}
                    gridProps={{ containLabel: false }}
                    xAxisProps={{ show: false }}
                    yAxisProps={{ show: false }}
                    zoomOnMouseWheel={false}
                    yTooltipSuffix={['€']}
                />
            </div>

            <div className={classes.Subtitle}>{revenue} €</div>
        </div>
    );
};

export default MonthsRevenueCard;
